
const state = {
  campaign_quote_id: undefined,
  campaign_quote_section_id: undefined,
  compulsory: false,
  custom_item_id: undefined,
  description: undefined,
  display_options: undefined,
  display_title: undefined,
  hidden: false,
  id: undefined,
  internal_notes: undefined,
  item_type: 'custom',
  locked: false,
  paid_by: 'vendor',
  price_override: undefined,
  price_type: 'fixed',
  price: undefined,
  provider_id: undefined,
  publication_edition_id: undefined,
  publication_week: undefined,
  required_by: undefined,
  row_title: undefined,
  selected: true,
  sort: undefined,
  title: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'campaign_quote_id' },
  { key: 'campaign_quote_section_id' },
  { key: 'item_type' },
  {
    key: 'price_override',
    validation: (priceOverride: string) => priceOverride !== '' && !Number.isNaN(Number(priceOverride)),
  },
  { key: 'title' },
]

export default state
